import angular from "angular";

angular
    .module('app')
    .component('courseDeleteModal', {
        template: require('./course-delete-modal.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;
    $ctrl.students = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.getActiveStudents();
    };

    $ctrl.getActiveStudents = function () {
        $http
            .get(`/admin/courses/${$ctrl.course.id}/getActiveStudents`)
            .then(
                function (response) {
                    $ctrl.students = response.data;
                },
                function (error) {

                }
            );
    };

    $ctrl.deleteCourse = function () {
        $http.delete(`/admin/courses/${$ctrl.course.id}/`).then(
            function (response) {
                Notifier.success('Курс успешно удален', 2);
                window.location = `/admin/courses`;
            },
            function () {
                Notifier.error('Произошла ошибка', 2)
            }
        );
    }
}
